class SiteHeaderAfix {

    constructor(header, config = {}) {

        this.header = header;
        this.config = { ...this.defaults, ...config };

        window.onscroll = this.onScroll.bind(this);

        // if (!('IntersectionObserver' in window)) {
        // } else {
        //     this.observer = new IntersectionObserver(entries => this.onIntersection(entries[0]), this.config);
        //     this.observer.observe(document.querySelector('.header-observer-root'));
        // }
    }

    /**
       * On intersection
       * @param Node entry
       */
    onIntersection(entry) {
        !entry.isIntersecting ? this.toggle(true) : this.toggle(false);
    }

    onScroll() {

        const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

        scrollTop >= 75 ? this.toggle(true) : this.toggle(false);

    }

    toggle(status) {
        if (status) {
            this.header.classList.add('fixed');
            document.body.classList.add('header-fixed');
        } else {
            this.header.classList.remove('fixed');
            document.body.classList.remove('header-fixed');
        }
    }

    get defaults() {
        return {
            rootMargin: '0px 0px 0px 0px',
            threshold: 0.95
        };
    }

}

const header = document.querySelector('#header');

if (header) {
    window.siteHeaderAfix = new SiteHeaderAfix(header);
}

export default SiteHeaderAfix;